import React, { useCallback } from 'react'
import { Text } from '@mantine/core'
import { handleWebShare } from '../utils/shareHandlers'

interface Props {
  onShareReward?: () => void
}

const SideShareActivity: React.FC<Props> = ({ onShareReward }) => {
  const handleShare = useCallback(async () => {
    const currentUrl = new URL(window.location.href)
    const shareUrl = `${currentUrl.origin}${currentUrl.pathname}`
    await handleWebShare(shareUrl)
  }, [])

  return (
    <>
      <div
        style={{
          position: 'fixed',
          right: 0,
          top: 'calc(16% + 80px)',
          transform: 'translateY(-50%)',
          zIndex: 100,
        }}
      >
        <div
          onClick={handleShare}
          style={{
            background: 'linear-gradient(180deg, #07C160 0%, #06AD56 100%)',
            borderRadius: '12px 0px 0px 12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '8px 12px',
            userSelect: 'none',
            boxShadow: '0 3px 12px rgba(7, 193, 96, 0.4)',
            transition: 'all 0.2s ease',
            minWidth: '90px',
            position: 'relative',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0 4px 16px rgba(7, 193, 96, 0.5)'
            e.currentTarget.style.transform = 'translateX(-2px)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0 3px 12px rgba(7, 193, 96, 0.4)'
            e.currentTarget.style.transform = 'translateX(0)'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 13,
                fontWeight: 600,
                lineHeight: '14px',
                textAlign: 'center',
                fontStyle: 'normal',
                textTransform: 'none',
                textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                letterSpacing: '0.3px',
              }}
            >
              分享活动
            </Text>
          </div>

          <div
            style={{
              marginLeft: 6,
              color: 'white',
              fontSize: 12,
              opacity: 0.8,
              lineHeight: 1,
            }}
          >
            📤
          </div>
        </div>
      </div>
    </>
  )
}

export default SideShareActivity
